import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { makeStyles } from "@material-ui/core";
import DoneIcon from "@material-ui/icons/Done";
import { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useSelector } from "react-redux";

interface MultiSelectCmpPropsType {
  options?: any[];
  onChange?: any;
  label?: string;
  value?: any[];
  name?: string;
  id?: string;
  changeMultiSelect?: any;
  responseValue?: GetStatusResponse[];
  renderOption?: any;
}
const useStyles = makeStyles((theme) => ({
  tag: {
    backgroundColor: "#5DA76D",
    height: 24,
    position: "relative",
    zIndex: 0,
    display: "flex !important",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "15px !important",
    paddingLeft: "5px !important",
    paddingRight: "5px !important",
    // left: "1.8vh !important",
    margin: "0px !important",
    marginRight: "5px !important",
  },
  root: {
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      // whiteSpace: "nowrap  !important",
      position: "initial",
      color: "#fff",
    },
  },
  inputRoot: {
    overflow: "inherit !important",
    "& .muirtl-6od3lo-MuiChip-label": {
      overflow: "inherit",
    },
    "& .muirtl-9iedg7": {
      overflow: "inherit",
    },
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      // whiteSpace: "nowrap  !important",
      // color: "#333",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0f8e2c !important",
      position: "absolout !important",
    },
    "& .muirtl-1h51icj-MuiAutocomplete-root .MuiAutocomplete-tag": {
      height: "100% !important",
      backgroundColor: "green !important",
    },
  },
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: "#0f8e2c !important",
    },
    backgroundColor: "#fff",
    "& .MuiAutocomplete-tag": {
      height: "100% !important",
      backgroundColor: "green !important",
    },
  },
}));
let mainColor: any;
let mainColor2: any;

export default function Autocomplate(props: MultiSelectCmpPropsType) {
  const [val, setVal] = useState<any[]>([]);
  const jsonFile = useSelector((state: any) => state.style);

  mainColor = jsonFile?.mainColor + "!important";
  mainColor2 = jsonFile?.mainColor;
  const useStyles = makeStyles((theme) => ({
    tag: {
      backgroundColor: mainColor2,
      // backgroundColor: "#5DA76D",
      height: 24,
      position: "relative",
      zIndex: 0,
      display: "flex !important",
      alignItems: "center",
      textAlign: "center",
      borderRadius: "15px !important",
      paddingLeft: "5px !important",
      paddingRight: "5px !important",
      // left: "1.8vh !important",
      margin: "0px !important",
      marginRight: "5px !important",
    },
    root: {
      "& .MuiAutocomplete-inputRoot": {
        overflow: "hidden !important",
        flexWrap: "nowrap !important",
        textOverflow: "ellipsis !important",
        // whiteSpace: "nowrap  !important",
        position: "initial",
        color: "#fff",
      },
    },
    inputRoot: {
      overflow: "inherit !important",
      "& .muirtl-6od3lo-MuiChip-label": {
        overflow: "inherit",
      },
      "& .muirtl-9iedg7": {
        overflow: "inherit",
      },
      "& .MuiAutocomplete-inputRoot": {
        overflow: "hidden !important",
        flexWrap: "nowrap !important",
        textOverflow: "ellipsis !important",
        // whiteSpace: "nowrap  !important",
        // color: "#333",
      },
      "&.Mui-focused fieldset": {
        borderColor: mainColor,
        // borderColor: "#0f8e2c !important",
        position: "absolout !important",
      },
      "& .muirtl-1h51icj-MuiAutocomplete-root .MuiAutocomplete-tag": {
        height: "100% !important",
        backgroundColor: "green !important",
      },
    },
    option: {
      '&[aria-selected="true"]': {
        // backgroundColor: "#0f8e2c !important",
        backgroundColor: mainColor,
        color: "#fff",
      },
      backgroundColor: "#fff",
      "& .MuiAutocomplete-tag": {
        height: "100% !important",
        backgroundColor: "green !important",
      },
    },
  }));
  const classes = useStyles();

  const handleChange = (event: object, value: any) => {
    setVal(value);

    let partialStudentDetails = value.map((item: any, index: number) =>
      value[index].id ? value[index].id : value[index]
    );
    props?.changeMultiSelect(partialStudentDetails, value);
  };
  React.useEffect(() => {
    setVal(props.responseValue!);
  }, [props.responseValue]);

  const [inputVal, setInputVal] = useState<string>("");

  const handleInputChange = (
    event: React.ChangeEvent<{}>,
    newInputValue: string,
    reason: string
  ) => {
    if (reason === "input") {
      setInputVal(newInputValue);
    }
  };

  return (
    <Autocomplete
      color={jsonFile?.muiColor}
      style={{ position: "inherit", direction: "rtl", color: "red" }}
      ChipProps={{ deleteIcon: <></> }}
      disableCloseOnSelect
      popupIcon={<KeyboardArrowDownIcon />}
      value={val}
      classes={classes}
      multiple
      clearOnBlur={false}
      onChange={handleChange}
      limitTags={0}
      id="multiple-limit-tags"
      options={props.options!}
      getOptionLabel={(option) => option?.title!}
      renderInput={(params) => (
        <TextField {...params} label={props.label} color={jsonFile?.muiColor} />
      )}
      disableClearable={true}
      // className="maxWidthAutocomplate"
      renderOption={props.renderOption}
      className="maxWidthAutocomplate autocomplete-none-text"
      inputValue={inputVal}
      onInputChange={handleInputChange}
    />
  );
}
